import { Icon } from '@/lib/icons';
import type { CollectionPlace, CollectionPlaceCopy } from '../collection-place.contract';

type PlaceSummaryProps = {
  copy: CollectionPlaceCopy;
  place: CollectionPlace;
  onChange: () => void;
};

export function PlaceSummary({ copy, place, onChange }: PlaceSummaryProps) {
  return (
    <div
      data-testid="collection-place-summary"
      className="flex items-center justify-between gap-3 rounded-2xl border border-primary/30 bg-primary/[0.06] px-4 py-3"
    >
      <div className="flex min-w-0 items-center gap-3">
        <Icon name="mapPin" className="h-4 w-4 shrink-0 text-primary" />
        <div className="min-w-0">
          <p className="text-[0.62rem] font-semibold uppercase tracking-[0.18em] text-muted-foreground/70">
            {place.source === 'geolocated' ? copy.detected : copy.chosen}
          </p>
          <p className="truncate text-sm font-semibold text-foreground">
            {place.city}
            <span className="font-normal text-muted-foreground">
              {' · '}
              {[place.region, place.countryName].filter(Boolean).join(', ')}
            </span>
          </p>
        </div>
      </div>
      <button type="button" onClick={onChange} className="shrink-0 text-xs font-semibold text-primary hover:text-primary/80">
        {copy.change}
      </button>
    </div>
  );
}
